import ErrorBoundary, { IProps } from './index'
import React, { ComponentType } from 'react'

export function withErrorBoundary<P>(
  WrappedComponent: ComponentType<P>,
  errorBoundaryProps: Omit<IProps, 'children'> = {}
): React.FC<P> {
  const WithErrorBoundary: React.FC<P> = (props) => (
    <ErrorBoundary {...errorBoundaryProps}>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  )

  const componentName = WrappedComponent.displayName || WrappedComponent.name

  WithErrorBoundary.displayName = componentName && `withErrorBoundary(${componentName})`

  return WithErrorBoundary
}
